import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

import { isTrialCommunity } from "@/react/helpers/communityHelpers";
import {
  isPlanBusiness,
  isPlanEnterprise,
  isPlanPlus,
} from "@/react/helpers/planHelpers";

export interface PlanRestrictions {
  currentPlanTier: string;
  isLegibleForAddonModal: boolean;
  isLegibleForUpgradePlanModal: boolean;
}

export const usePlanRestrictions = (): PlanRestrictions => {
  const { currentCommunity, currentCommunityMember } = usePunditUserContext();
  const currentPlanTier = currentCommunity?.current_plan_tier || "";
  const isAdmin = Boolean(currentCommunityMember?.is_admin);

  const isLegibleForUpgradePlanModal =
    !isPlanBusiness(currentPlanTier) &&
    !isPlanEnterprise(currentPlanTier) &&
    !isPlanPlus(currentPlanTier) &&
    isAdmin;

  const isLegibleForAddonModal =
    (isPlanBusiness(currentPlanTier) || isPlanEnterprise(currentPlanTier)) &&
    !isTrialCommunity(currentCommunity) &&
    isAdmin;

  return {
    currentPlanTier,
    isLegibleForAddonModal,
    isLegibleForUpgradePlanModal,
  };
};
